import React, { useMemo } from "react";
import SimpleTable from "../../../../../shared/components/common/ui/SimpleTable";
import IconResolver from "../../../../../shared/components/common/ui/IconResolver";
import StatusLabel from "../../../../../shared/components/StatusLabel/StatusLabel";
import themeColors from "../../../../../shared/components/ThemeColors/ThemeColors";

const AudienceGrid = ({ rows, loading, selectionModel, onSelectionChange }) => {
  const columns = useMemo(
    () => [
      {
        field: "icon",
        headerName: "",
        width: 80,
        sortable: false,
        renderCell: (params) => (
          <IconResolver
            name={params.value}
            color={themeColors.purple500}
            size={18}
          />
        ),
      },
      {
        field: "title",
        headerName: "Título",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "desc",
        headerName: "Descrição",
        flex: 1.5,
        minWidth: 320,
      },
      {
        field: "type",
        headerName: "Tipo",
        flex: 1,
        minWidth: 160,
        renderCell: (params) => (
          <StatusLabel status={params.value} usingOnTable />
        ),
      },
    ],
    [],
  );

  return (
    <SimpleTable
      data={rows}
      loading={loading}  
      columns={columns}
      mode="selection"
      selectionModel={selectionModel}
      onSelectionChange={onSelectionChange}
      hideHeaderActions
      hideFooter
    />
  );
};

export default AudienceGrid;
